'use strict'
import InputError from './lib/InputError';
import Failed from './lib/Failed';

class Complaint {

    constructor(options) {
        var self=this;
        grecaptcha.enterprise.ready(async () => {
            self.recaptcha_token = await grecaptcha.enterprise.execute(options.access_key, {action: 'LOGIN'});
        });
        $("#simViewMore").on('click', function(e) {
            e.preventDefault();
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(this).children('span').text('Seguir leyendo');
                $("#viewMoreContent").slideUp();
            } else {
                $(this).addClass('active');
                $(this).children('span').text('Leer menos');
                $("#viewMoreContent").slideDown();
            }
        });
    }

    init () {
        var self=this;
        ['name', 'second_name', 'last_name', 'second_surname', 'ci', 'date_of_birth', 'departament', 'city', 'address', 'phone', 'email'].forEach(function (inp){
            let input = $('form[name="complaint"]').find('input[name="'+ inp +'"]')[0];
            if($(input).val() !== ''){
                $(input).parent().addClass('focused');
            }
        });
        $('form[name="complaint"]').on('submit', (e) => {            
            $(e.currentTarget).find('button[type="submit"]').loading();
            InputError.reset();

            var data_form=$(e.currentTarget).serialize();
            data_form=data_form+'&g-recaptcha-response='+self.recaptcha_token;

            $.ajax({
                url: $(e.currentTarget).attr('action'),
                type : "POST",
                dataType : 'json',
                data : data_form,
                success : (data) => {
                    $(e.currentTarget).find('button[type="submit"]').finish();
                    if (data.status === 1){
                        return Failed.success({
                            icon:{
                                type:'icon--success',
                                src:'ic-success-result.svg'
                            },
                            'title': 'Tu consulta ha sido enviada.',
                            'description':'Un representante de Servicio al Cliente te contactará. ¡Gracias!',
                        });
                    }
                    if (data.status === 2){
                        return Failed.show(data.message);
                    }
                    InputError.validate();
                    if (data.error){
                        InputError.show(data.error);
                    }
                },
                error: function(xhr, resp, text) {
                    $(e.currentTarget).find('button[type="submit"]').finish();
                    console.log(xhr, resp, text);
                }
            });
            return false;
        });
    }
}

export default Complaint;